module.exports = __webpack_public_path__ + "static/icon-7b23dda97e1cb40e9bab418d0c9221db.png";